import {mapActions, mapGetters, mapMutations} from 'vuex'

export const clientMixin = {
  computed: {
    ...mapGetters({
      'clients': 'clients/all',
      'stats': 'clients/stats',
      'client': 'clients/client'
    }),
    clientId () {
      return this.$route.params.id
    }
  },
  methods: {
    ...mapActions({
      'getClients': 'clients/getClients',
      'getClientStats': 'clients/getUsageStats',
      'getClient': 'clients/getClient',
      'getClientOverview': 'clients/getClientOverview',
      'updateClient': 'clients/updateClient',
      'addClient': 'clients/addClient',
      'deleteClient': 'clients/deleteClient',
      'uploadImage': 'clients/uploadImage',
      'deleteImage': 'clients/deleteImage'
    }),
    ...mapMutations({
      'resetClient': 'clients/resetSingleClient'
    })
  }
}



// WEBPACK FOOTER //
// ./src/mixins/clientMixin.js